import { AppStateComponents } from '../../../utils/constants';
import { FormView } from '../base/Form';
export class ContactsView extends FormView {
    constructor(container, event) {
        super(container, event);
        this.event = event;
    }
    onInputChange(field, value) {
        this.events.emit(AppStateComponents.CONTACT.INPUT, { field, value });
    }
}
